import { render, staticRenderFns } from "./SideBarRight.vue?vue&type=template&id=bf6f65b0"
import script from "./SideBarRight.vue?vue&type=script&lang=js"
export * from "./SideBarRight.vue?vue&type=script&lang=js"
import style0 from "./SideBarRight.vue?vue&type=style&index=0&id=bf6f65b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports